
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.05 6c0 .797-.152 1.555-.457 2.273a5.802 5.802 0 01-1.254 1.864 5.805 5.805 0 01-1.863 1.254 5.765 5.765 0 01-2.274.457 5.765 5.765 0 01-2.273-.457 5.802 5.802 0 01-1.863-1.254A5.802 5.802 0 01.812 8.273 5.765 5.765 0 01.355 6c0-.797.152-1.555.457-2.273a5.803 5.803 0 011.254-1.864A5.786 5.786 0 013.929.61 5.765 5.765 0 016.202.152 5.76 5.76 0 018.476.61a5.802 5.802 0 011.863 1.254c.54.54.957 1.16 1.254 1.864.305.718.457 1.476.457 2.273zM9.284 3.75L5.312 7.84v.012a.12.12 0 01-.088.035.12.12 0 01-.088-.035l-2.04-2.075a.593.593 0 00-.433-.17.587.587 0 00-.422.188.615.615 0 000 .861L4.27 8.72a1.32 1.32 0 00.972.392 1.42 1.42 0 00.961-.404l3.985-4.113a.602.602 0 00.152-.44.595.595 0 00-.193-.422.591.591 0 00-.434-.164.603.603 0 00-.428.182z","fill":"#8DC540"}})])
          )
        }
      }
    